export const PERKS_FILTER_CATEGORIES = "CATEGORIES";
export const PERKS_FILTER_COUNTRIES = "COUNTRIES";
export const PERKS_SORT_MOST_POPULAR = "MOST_POPULAR";
export const PERKS_SORT_NAME_ASCENDING = "NAME_ASCENDING";
export const PERKS_SORT_NAME_DESCENDING = "NAME_DESCENDING";
export const PERKS_SORT_RECENTLY_ADDED = "RECENTLY_ADDED";
